<template>
    <data-hud class="data-hud" :title="t('vital_signs.stress.title')" :text="text" unit="" :data="data"/>
</template>

<script>
import DataHud from "./data-hud.vue"
import { useI18n } from 'vue-i18n';

export default 
  {
    name: 'stress-rating',
    props: {
        data: [Number, String],
    },
    data() {
        return {
            text: "Stress level is a feeling of emotional or physical tension. High level of stress may be caused by any event or thought that makes you feel frustrated, angry, or nervous."
        }
    },
    setup() {
    const { t, locale } = useI18n()
    return {t, locale}
    },
    components: { DataHud }
}
</script>

<style scoped>
.data-hud {
    position: relative;
}
@media (max-width: 1044px) {
    .data-hud {
        position: relative;
        margin-left: 10px;
        right: auto;
        top: auto;
    }
}
</style>


